export default __webpack_public_path__ + "static/media/25.50df0ba8.png";